import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { ValidationIcon } from './validation-icon'

import styles from './password-validation-icon.module.css'

const propTypes = {
    type: PropTypes.oneOf(['weak', 'normal', 'strong'])
}

const defaultProps = {
    type: 'strong'
}

/**
 * @todo [WFICON-61] Move or rework PasswordValidationIcon
 *
 * @param {string} type - The password strength type.
 * @param {object} props - Component properties passed down to the icon.
 * @returns {ReactElement} React component
 */
function PasswordValidationIcon({ type, ...props }) {
    const testClassName = 't3sel-strength-icon'
    const strengthClass = `t3sel-${type}`
    return (
        <div className={cx(styles['password-validation-icon'], styles[type], testClassName, strengthClass)}>
            <ValidationIcon {...props} />
        </div>
    )
}

PasswordValidationIcon.propTypes = propTypes
PasswordValidationIcon.defaultProps = defaultProps

export { PasswordValidationIcon }
